import 'jquery';
import modules from './modules/modules.js';
import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()
modules();
